import { IS_DESKTOP } from '@/utils/checkClientDeviceType';
import ModernFormDesktop from './Desktop';
import ModernFormMobile from './Mobile';

const ModernForm1 = (props) => {
  return IS_DESKTOP ? <ModernFormDesktop {...props} /> : <ModernFormMobile {...props} />;
};

export default ModernForm1;
